import { IFilterConfig } from '../../filter/interfaces';

const filterConfig :IFilterConfig[] = [
  {
    id: 'orderNo',
    type: 'input',
    label: 'Order #',
    query: 'orderNo',
    show: true,
  },
  {
    id: 'sourceWarehouseIds',
    type: 'locations',
    label: 'Source Warehouse',
    query: 'sourceWarehouseIds',
    show: true,
    config: {
      inlineChips: true,
    },
  },
  {
    id: 'destinationWarehouseIds',
    type: 'locations',
    label: 'Destination Warehouse',
    query: 'destinationWarehouseIds',
    show: true,
    config: {
      inlineChips: true,
    },
  },
  {
    id: 'orderDate',
    type: 'date',
    label: 'Order Date',
    query: 'orderDate',
    show: true,
  },
  {
    id: 'arrivalDate',
    type: 'date',
    label: 'Arrival Date',
    query: 'arrivalDate',
    show: false,
  },
  {
    id: 'createdDate',
    type: 'date',
    label: 'Created At',
    query: 'createdDate',
    show: false,
  },
  {
    id: 'updatedDate',
    type: 'date',
    label: 'Updated At',
    query: 'updatedDate',
    show: false,
  },
  {
    id: 'supplierPoNo',
    type: 'input',
    label: 'PO #',
    query: 'supplierPoNo',
    show: false,
  },
  {
    id: 'createdBy',
    type: 'users',
    label: 'Created By',
    query: 'createdBy',
    show: false,
  },
  {
    id: 'updatedBy',
    type: 'users',
    label: 'Updated By',
    query: 'updatedBy',
    show: false,
  },
  {
    id: 'salesOrderNo',
    type: 'input',
    label: 'Sales Order #',
    query: 'salesOrderNo',
    show: false,
  },
];

const columnConfig :{
  id :string;
  label :string;
  visible :boolean;
  relation ?:string;
}[] = [
  {
    id: 'orderNo',
    label: 'Order #',
    visible: true,
  },
  {
    id: 'orderDate',
    label: 'Order Date',
    visible: true,
  },
  {
    id: 'orderStatus',
    label: 'Order Status',
    visible: true,
  },
  {
    id: 'arrivalDate',
    label: 'Arrival Date',
    visible: true,
  },
  {
    id: 'sourceWarehouse',
    label: 'Source Warehouse',
    visible: true,
    relation: 'sourceWarehouse',
  },
  {
    id: 'destinationWarehouse',
    label: 'Destination Warehouse',
    visible: true,
    relation: 'destinationWarehouse',
  },
  {
    id: 'createBy',
    label: 'Created By',
    relation: 'createdBy',
    visible: false,
  },
  {
    id: 'updatedBy',
    label: 'Updated By',
    visible: false,
    relation: 'updatedBy',
  },
  {
    id: 'createdAt',
    label: 'Created At',
    visible: false,
  },
  {
    id: 'updatedAt',
    label: 'Updated At',
    visible: false,
  },
  {
    id: 'supplierPoNo',
    label: 'Purchase Order',
    visible: true,
    relation: 'supplierPurchaseOrder',
  },
  {
    id: 'salesOrderNo',
    label: 'Sales Order',
    visible: true,
    relation: 'salesOrder',
  },
  {
    id: 'lineItems',
    label: 'Line Items',
    visible: false,
    relation: 'orderItems',
  },
];

export const TransferOrderConfig = {
  filterConfig,
  columnConfig,
};
